/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Preset_YearInputs */

const vi_warehouse_sales_preset_year = /** @type {(inputs: Warehouse_Sales_Preset_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Năm nay`)
};

/**

* @param {Warehouse_Sales_Preset_YearInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_preset_year = /** @type {((inputs?: Warehouse_Sales_Preset_YearInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Preset_YearInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_preset_year(inputs)
});